import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { VimeoPlayableService } from 'src/app/services/vimeo-playable-url.service';

/**
 * Takes in a vimeoId, and returns an observable with an HTML playable video url
 */
@Pipe({
  name: 'vimeoPlayableUrl',
  pure: true
})
export class VimeoPlayableUrl implements PipeTransform {
  constructor(private $vimeoPlayable: VimeoPlayableService) {}

  transform(videoId: string): Observable<string> {
    return this.$vimeoPlayable.fetch(videoId);
  }

}
